export class Constants {
    static url = process.env.REACT_APP_BACKEND_URL;
    static authLoginUrl = `${Constants.url}${process.env.REACT_APP_AUTH_LOGIN_PATH}`;
    static authLogoutUrl = `${Constants.url}${process.env.REACT_APP_AUTH_LOGOUT_PATH}`;
    static backgroundImagePositionTiled = 'tiled';
    static backgroundImagePositionCentered = 'centered';
    static buildDate = process.env.REACT_APP_BUILD_DATE;
    static buildRev = process.env.REACT_APP_BUILD_REV;
}
